import {Component, Input, OnInit, ViewChild} from '@angular/core'
import {FormGroup} from '@angular/forms'
import {ReCaptcha2Component} from 'ngx-captcha'

@Component({
  selector: 'dmmp-form-captcha',
  templateUrl: './captcha.component.html',
})
export class CaptchaComponent implements OnInit {
  @Input() field
  @Input() identifier
  @Input() keyCaptcha
  @Input() group: FormGroup
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component
  status

  constructor() {
  }

  ngOnInit() {
  }

  updateValidation() {
    setTimeout(() => {
      this.captchaElem.resetCaptcha()
    }, 800)
  }
}
